/* eslint-disable */ import { assertBoolean, assertNumber, attributeSwitchComponent, genericDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const countersinkComponents = [
    attachAdminComponent.withComponent(genericDimensionComponent, 'plateThicknessMin', true).withEntity('Countersink').attach(memoEval((self)=>[
            self.plateThicknessMin
        ], (plateThicknessMin)=>({
            value: plateThicknessMin,
            min: 0.1,
            max: 10,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        return {
            plateThicknessMin: state.value
        };
    }),
    attachAdminComponent.withComponent(genericDimensionComponent, 'plateThicknessMax', true).withEntity('Countersink').attach(memoEval((self)=>[
            self.plateThicknessMax
        ], (plateThicknessMax)=>({
            value: plateThicknessMax,
            min: 0.1,
            max: 10,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        return {
            plateThicknessMax: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSwitchComponent, 'visible', true).withEntity('Countersink').attach(memoEval((self)=>[
            self.visible
        ], (visible)=>({
            value: visible
        })), (state)=>{
        assertBoolean(state.value);
        return {
            visible: state.value
        };
    })
];

//# sourceMappingURL=countersink.js.map